module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu6.8acc6503.png";